$(document).ready(function(){
	var newSideMenuA = $(".new-menu__sideA");
	var sideMenuA = $(".menuA-side-wrapper");
	console.log(sideMenuA);
	var sideMenuB = $(".menuA-side-wrapper").find(".new-menu__sideB");
	var contentWrapper = $(".new-menu-wrapper").parent();
	var globalSearch = $('div[data-component="GlobalSearch"]');
	var oldBurger = $(".section-burger.sectionCta.content-target__burger.js-open-menuFullWindow");
	if(globalSearch.length > 0){
		sideMenuA.insertBefore(globalSearch);
	} else {
		sideMenuA.insertBefore(oldBurger);
	}
//	sideMenuA.insertBefore(globalSearch);
	sideMenuB.insertAfter(contentWrapper);
	sideMenuB.addClass("hide");
	if(newSideMenuA.hasClass("editorial") || sideMenuB.hasClass("editorial")){
		
		var clickedElem = "";
		$(".navigation__primary__link.new-link-menu").click(function(e){
			if($(this)[0] != clickedElem[0]){
				if(!$(this).parent().hasClass("our-group-link-desktop")){
					sideMenuB.removeClass("hide");
				}
				clickedElem = $(this);
			} else {
				sideMenuB.addClass("hide");
				clickedElem = "";
			}
		});
		
	} else {
		
		$(".navigation__primary__link.new-link-menu").mouseenter(function(e){
				$(this).click();
				if(!$(this).parent().hasClass("our-group-link-desktop")){
					sideMenuB.removeClass("hide");
				} else {
					sideMenuB.addClass("hide");
				}
		});
		$(".menuFullWindow__sideB.menuFullWindow__scollWindow.new-menu__sideB").mouseleave(function(e){
			sideMenuB.addClass("hide");
		});
		
	}
	$(".-js-open-search").click(function(){
		sideMenuA.addClass("hide");
	});
	$(".-js-close-search").click(function(){
		sideMenuA.removeClass("hide");
	});
	$(".new-menu__sideB.editorial").find(".menuFullWindow__tabPanel").click(function(){
		console.log($(this));
		if($(this).prev().hasClass("openMenu")){
			$(this).prev().prev().attr("style", "display:flex");
		}
	});
//	$(".new-menu__sideB__split").each(function(){
//		var element = $(this);
//		var clonedElement = element.clone();
//		var parent = element.parent();
//		var newParent = parent.clone();
//		newParent.html("");
//		clonedElement.removeClass("hide");
//		newParent.append(clonedElement);
//		newParent.insertAfter(parent);
//		
//	});
	
	/*$(".new-menu__sideA").click(function(){
		var editorBar = $(".menuFullWindow__sideA.col-md-8.col-sm-10.hidden-xs").prev().clone(true, true);
		//console.log(editorBar);
		//console.log($(this).prev());
		//console.log($(this).prev().hasClass("mgnlEditorBar"));
		if($(this).prev().hasClass("mgnlEditorBar")){
			$(this).prev().remove();
		}
		editorBar.insertBefore($(this));
		$(".new-menu__sideB").find("div.mobileControl.row").prev().hide();
		$(".new-menu__sideB").find("div.mobileControl.row.openMenu").prev().show();
		
		
	});*/
	
	
	if(($(".navigation__primary__item.new-parent-menu").hasClass("active"))|| ($(".navigation__primary__item.new-parent-menu.new-tworow-menu").hasClass("active"))){
			$(".navigation__primary__item.new-parent-menu.active").removeClass("active");
			$(".navigation__primary__item.new-parent-menu.new-tworow-menu.active").removeClass("active");
	}else{
		
		$(".navigation__primary__item.new-parent-menu.active").removeClass("active");
		$(".navigation__primary__item.new-parent-menu.new-tworow-menu.active").removeClass("active");
	}
	
});

$(".menuA-side-wrapper").mouseleave(function(e){       
	 setTimeout(function(){
		if ($(".menuFullWindow__sideB.menuFullWindow__scollWindow.new-menu__sideB").hasClass("hide")){    
			$(".navigation__primary__item.new-parent-menu.active:not(.our-group-link-desktop)").removeClass("active");
		}
	}, 1000);
	if ($(".menuFullWindow__sideB.menuFullWindow__scollWindow.new-menu__sideB").hasClass("hide")){    
		$(".navigation__primary__item.new-parent-menu.active.our-group-link-desktop").removeClass("active");
	}
});

$( document).ready(function() {
	var menuItemsMobile = document.querySelectorAll(".mobileControl__link");
	  if (window.navigator.userAgent.indexOf("MSIE ") != -1){
	      	menuItemsMobile = Array.prototype.slice.call(menuItemsMobile);
	      }
		menuItemsMobile.forEach(function(entry) {
			var itemHTML = entry.innerHTML; 		
			var itemMobile=itemHTML.replace(/\s\s+/g, ' ');
				itemMobile= itemMobile.replace(/amp;/g, "");
		entry.innerText = itemMobile;
		})
});

$( document).ready(function() {
	if($(window).width()==1024){
		  $(".navigation__primary__link ").addClass("mobileview");
		} else if($(window).width()>1280){
		  $(".navigation__primary__link ").removeClass("mobileview");
		}
	menuItemsTablet= document.querySelectorAll(".mobileview");
	  if (window.navigator.userAgent.indexOf("MSIE ") != -1){
	      	menuItemsTablet = Array.prototype.slice.call(menuItemsTablet);
	      }
	menuItemsTablet.forEach(function(entry) {
		var itemHTMLTablet = entry.innerHTML; 		
		var itemTablet=itemHTMLTablet.replace(/\s\s+/g, ' ');
			itemTablet= itemTablet.replace(/amp;/g, "");
	entry.innerText = itemTablet;
	})
});
